import * as React from 'react';

var _path, _path2, _path3, _path4;
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgTools = function SvgTools(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        className: "tools_svg__icon tools_svg__icon--tools",
        width: 24,
        height: 24,
        fill: "none",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.243 12.47a.75.75 0 0 1 1.06 0l3.182 3.182a.75.75 0 0 1 0 1.06l-6.364 6.36A3 3 0 0 1 .88 18.83l6.364-6.36Zm.53 1.59-5.834 5.83a1.5 1.5 0 0 0 2.122 2.122l5.833-5.83-2.121-2.121Z",
        fill: "currentColor"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.91 5.042a.75.75 0 0 1 0 1.06l-9.016 9.015a.75.75 0 0 1-1.06-1.06l9.015-9.015a.75.75 0 0 1 1.06 0Z",
        fill: "currentColor"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.5.27a.75.75 0 0 1 1.061 0l2.121 2.12a.75.75 0 0 1 0 1.06L21.03 6.102A2.25 2.25 0 1 1 17.85 2.92L20.5.27Zm.53 1.59-2.12 2.12a.75.75 0 0 0 1.06 1.062L22.09 2.92l-1.06-1.06ZM4.486.552a.75.75 0 0 1 .712-.35 4.458 4.458 0 0 1 2.693 1.272l.003.002A4.498 4.498 0 0 1 9.056 5.82l1.965 1.97A.75.75 0 1 1 9.959 8.85L7.67 6.555a.75.75 0 0 1-.167-.804 2.998 2.998 0 0 0-.669-3.214 2.958 2.958 0 0 0-.527-.416 3.743 3.743 0 0 1-4.128 4.135l.014.023a2.97 2.97 0 0 0 3.604 1.17.75.75 0 0 1 .807.167L8.18 9.192a.75.75 0 1 1-1.06 1.06l-1.25-1.25a4.47 4.47 0 0 1-5.615-3.85.75.75 0 0 1 1.143-.714 2.243 2.243 0 0 0 3.09-3.092.75.75 0 0 1-.001-.794ZM15.092 12.922a.75.75 0 0 1 1.06 0l2.186 2.185a4.5 4.5 0 1 1-3.182 3.182l-1.45-1.449a.75.75 0 0 1 1.061-1.06l1.775 1.774a.75.75 0 0 1 .168.804 3 3 0 1 0 1.697-1.697.75.75 0 0 1-.804-.168l-2.511-2.51a.75.75 0 0 1 0-1.061Z",
        fill: "currentColor"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.704 18.656a1.125 1.125 0 1 0 1.592 1.59 1.125 1.125 0 0 0-1.592-1.59Z",
        fill: "currentColor"
    })));
};

export { SvgTools as default };
//# sourceMappingURL=tools-1d33cd3e.js.map
